module.exports = __webpack_public_path__ + "static/media/back_nav_bar_icon.226c8cf4.svg";